import { action } from 'utils/actions'

export const CROPPER_SELECT = 'CROPPER_SELECT'
export const CROPPER_VALID = 'CROPPER_VALID'
export const CROPPER_INVALID = 'CROPPER_INVALID'
export const CROPPER_ERROR = 'CROPPER_ERROR'
export const CROPPER_CANCEL = 'CROPPER_CANCEL'
export const CROPPER_SAVE = 'CROPPER_SAVE'
export const CROPPER_RESET = 'CROPPER_RESET'

export const cropperSelect = (file) => action(CROPPER_SELECT, { file })
export const cropperValid = (file, src) => action(CROPPER_VALID, { file, src })
export const cropperInvalid = (file, error) => action(CROPPER_INVALID, { file, error })
export const cropperError = (file, error) => action(CROPPER_ERROR, { file, error })
export const cropperCancel = (file) => action(CROPPER_CANCEL, { file })
export const cropperSave = (file, imagePreview) => action(CROPPER_SAVE, { file, imagePreview })
export const cropperReset = () => action(CROPPER_RESET)



/** WEBPACK FOOTER **
 ** ./src/actions/cropper/cropper-actions.js
 **/